import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const ERROR_MESSAGE_LOAD_ANSWER = 'error message load answer'
export const TAKE_A_WHILE_TO_LOAD = 'take a while to load'
export const LOAD_BLOCKED = 'load_blocked___'

export default {
  [PORTUGUESE]: {
    [ERROR_MESSAGE_LOAD_ANSWER]: 'Ocorreu um erro ao carregar as respostas',
    [TAKE_A_WHILE_TO_LOAD]: starts =>
      `Esta pesquisa tem ${starts} respostas. Pode demorar um pouco para carregá-las.`,

    [LOAD_BLOCKED]:
      'Essa pesquisa possui mais de 4500 respostas. Para visualizá-las, você deverá baixar os dados',
  },

  [ENGLISH]: {
    [ERROR_MESSAGE_LOAD_ANSWER]: 'There was an error while loading the answers',
    [TAKE_A_WHILE_TO_LOAD]: starts =>
      `This survey has ${starts} answers. It might take a while to load them.`,

    [LOAD_BLOCKED]:
      'This survey has more than 4500 answers. To visualize them, you will need to download it first',
  },

  [SPANISH]: {
    [ERROR_MESSAGE_LOAD_ANSWER]: 'Hubo un error al cargar las respuestas',
    [TAKE_A_WHILE_TO_LOAD]: starts =>
      `Esta encuesta tiene ${starts} respuestas. Puede tomar un tiempo cargarlos.`,

    [LOAD_BLOCKED]:
      'Esta encuesta tiene mais de 4500 respostas. Descargarlos para procesar.',
  },
}
